<template>
  <div>
    <gravy-image-dropdown-menu v-if="clients" label="Select a Client" ref="clientChildRef" :items="clients" />
    <gravy-image-dropdown-menu class="mt-5" v-if="clients" label="Select a Product" ref="clientChildRef" :items="clients" />

<!--    <Suspense>-->
      <div class="hidden sm:block">
        <div class="mt-5 mx-auto px-4 sm:px-6 lg:px-8">
          <div class="flex flex-col mt-2">
            <div class="align-middle min-w-full overflow-x-auto shadow overflow-hidden sm:rounded-lg">
              <h1 class="my-3 p-4 text-xl">Tasks</h1>
              <table v-if="tasks" class="min-w-full divide-y divide-gray-200">
                <thead>
                <tr>
                  <th class="px-6 py-3 bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Tasks
                  </th>
                  <th class="px-6 py-3 bg-gray-50 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Description
                  </th>
                  <th class="hidden px-6 py-3 bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider md:block">
                    Status
                  </th>
                  <th class="px-6 py-3 bg-gray-50 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Date
                  </th>
                </tr>
                </thead>
                <tbody class="bg-white divide-y divide-gray-200">
                <tr v-for="task in tasks" :key="task.id" class="bg-white">
                  <td class="max-w-0  px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                    <div class="flex">
                      <a href="#" class="group inline-flex space-x-2 truncate text-sm">
                        <!--                      <CashIcon class="flex-shrink-0 h-5 w-5 text-gray-400 group-hover:text-gray-500" aria-hidden="true" />-->
                        <p class="text-gray-500 truncate group-hover:text-gray-900">
                          {{ task.name }}
                        </p>
                      </a>
                    </div>
                  </td>
                  <td class="px-6 py-4 text-right whitespace-nowrap text-sm text-gray-500">
                    <!--                  <span class="text-gray-900 font-medium">{{ transaction.amount }} </span>-->
                    {{ task.description }}
                  </td>
                  <td class="hidden px-6 py-4 whitespace-nowrap text-sm text-gray-500 md:block">
                    <Switch @click.prevent="task.completed = !task.completed" v-model="task.completed" :class="[task.completed ? 'bg-brand-primary' : 'bg-gray-200', 'relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500']">
                      <span class="sr-only">Use setting</span>
                      <span aria-hidden="true" :class="[task.completed ? 'translate-x-5' : 'translate-x-0', 'pointer-events-none inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200']" />
                    </Switch>
                    <span class="' items-center px-2.5 my-auto rounded-full text-lg font-medium capitalize'" v-html="task.completed ? 'Completed' : 'Incomplete'">

                  </span>
                  </td>
                  <td class="px-6 py-4 text-right whitespace-nowrap text-sm text-gray-500">
                    <time :datetime="new Date()">{{ new Date()  }}</time>
                  </td>
                </tr>
                </tbody>
              </table>
              <!-- Pagination -->
              <nav class="bg-white px-4 py-3 flex items-center justify-between border-t border-gray-200 sm:px-6" aria-label="Pagination">
                <div class="hidden sm:block">
                  <p class="text-sm text-gray-700">
                    Showing
                    {{ ' ' }}
                    <span class="font-medium">1</span>
                    {{ ' ' }}
                    to
                    {{ ' ' }}
                    <span class="font-medium">10</span>
                    {{ ' ' }}
                    of
                    {{ ' ' }}
                    <span class="font-medium" v-if="tasks"> {{ tasks.length }}</span>
                    {{ ' ' }}
                    results
                  </p>
                </div>
                <div class="flex-1 flex justify-between sm:justify-end">
                  <a href="#" class="relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50">
                    Previous
                  </a>
                  <a href="#" class="ml-3 relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50">
                    Next
                  </a>
                </div>
              </nav>
            </div>
          </div>
        </div>
      </div>
<!--    </Suspense>-->

  </div>
</template>

<script>
import GravyImageDropdownMenu from "@/components/GravyImageDropdownMenu";

import { Switch } from '@headlessui/vue'
export default {
  name: "Tasks",
  components: {GravyImageDropdownMenu, Switch},
  mounted() {
    this.$store.commit('getClients')
    this.$store.commit('getProducts')
    this.$store.commit('getTasks')
  },
  computed: {
    clients() {
      return this.$store.getters.getClients
    },
    products() {
      return this.$store.getters.getProducts
    },
    tasks() {
      return this.$store.getters.getTasks
    }
  }
}
</script>

<style scoped>

</style>